App.namespace('es6.shared.cookie', () => {
  const set = (name, value, days, secure) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

    let cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    if (secure) {
      cookie += ';secure';
    }

    document.cookie = cookie;
  };

  const get = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  const remove = (name) => {
    document.cookie = `${name}=; Max-Age=-99999999;`;
  };

  return {
    set,
    get,
    remove,
  };
});
